import React from "react";

const IncreaseSalary = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M24.563 24.485H34v3.806h-9.438v-3.806zM24.563 30.194H34V34h-9.438v-3.806zM24.563 18.775H34v3.806h-9.438v-3.806zM7.25 20.776l-1.301-.014-.082-1.898c6.96-.689 13.212-4.613 16.92-10.567L20.531 7.23 29.006 2l1.5 9.951-2.61-1.235c-1.78 2.71-4.654 6.032-8.788 7.828-4.247 1.845-8.793 2.232-11.858 2.232zM11.438 34H2v-3.806h9.438V34zM13.313 24.485h9.374v3.806h-9.375v-3.806zM13.313 30.194h9.374V34h-9.375v-3.806z"
          fill={fill}
      />
    </svg>
);
export default IncreaseSalary;
